// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import ValidationAndVsrErrorMessages from '../validation-and-vsr-error-messages';

const InputWithError = props => {

    const {errorMessage, isValid, vsrMessage, ...rest} = props;

    return (
        <span>
            <input
                {...rest}
            />
            <ValidationAndVsrErrorMessages
                errorMessage={errorMessage}
                isValid={isValid}
                vsrMessage={vsrMessage}
            />
        </span>
    );

};

InputWithError.displayName = 'InputWithError';
InputWithError.propTypes = {
    errorMessage: PropTypes.string.isRequired,
    isValid: PropTypes.bool.isRequired,
    vsrMessage: PropTypes.string
};

export default InputWithError;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-fields/input-with-error.js